// filepath: src/pages/matrimony/components/sectionForms/AstroEditForm.tsx
import React from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Select,
} from "@chakra-ui/react";
import { commonInputProps, commonSelectProps } from "src/pages/matrimony/pages/matrimonyForm.ui";
import { FIELD_LABELS } from "src/utils/matrimonyFieldLabels";
import {
  DOSHAM_OPTIONS,
  NAKSHATRA_OPTIONS,
  RASI_OPTIONS,
} from "src/utils/matrimonyOptions";
import type { AstroState } from "src/types/marriageProfileSectionEdit.types";
import type { BaseSectionFormProps } from "./sectionFormProps";

type Props = BaseSectionFormProps & { values: AstroState };

const AstroEditForm: React.FC<Props> = ({ values, errors: _errors, setField }) => (
  <>
    <FormControl>
      <FormLabel>{FIELD_LABELS.NAKSHATRA}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.nakshatra || ""}
        onChange={(e) => setField("nakshatra", e.target.value)}
        placeholder="Select Nakshatra"
      >
        {NAKSHATRA_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.RASI}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.rasi || ""}
        onChange={(e) => setField("rasi", e.target.value)}
        placeholder="Select Rasi"
      >
        {RASI_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.GOTHRAM}</FormLabel>
      <Input
        {...commonInputProps}
        value={values.gothram || ""}
        onChange={(e) => setField("gothram", e.target.value)}
      />
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.DOSHAM}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.dosham || ""}
        onChange={(e) => setField("dosham", e.target.value)}
        placeholder="Select dosham"
      >
        {DOSHAM_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.TIME_OF_BIRTH}</FormLabel>
      <Input
        {...commonInputProps}
        type="time"
        value={values.timeOfBirth || ""}
        onChange={(e) => setField("timeOfBirth", e.target.value)}
      />
    </FormControl>
  </>
);

export default AstroEditForm;
